module.exports = __webpack_public_path__ + "img/img1.5a80e3ed.png";